export const ANALYTICS_PACKAGE_NAME = 'issueFieldsServiceEntity';
export const COMPASS_COMPONENT_PROPERTY = 'compass_component';
